import Vue from "vue";
import Vuex from "vuex";

import headerModule from "./modules/header";
import userModule from "./modules/user";
import paymentModule from "./modules/payment";
import change from "./modules/change";
import customize from "./modules/customize";
import reminderInfoModule from "./modules/reminderInfo";
import module from "./modules/module";

Vue.use(Vuex);

export default new Vuex.Store({
  /*state: {
  },
  mutations: {
  },
  actions: {
  },*/
  modules: {
    header: headerModule,
    user: userModule,
    payment: paymentModule,
    change: change,
    customize: customize,
    module: module,
    reminderInfo: reminderInfoModule
  },
});
